import { CommonModule, JsonPipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { ForceCheckOutUtilityService } from '../../Model/ForceCheckOutUtility/force-check-out-utility.service';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { DownloadSampleService } from '../../Model/DownloadSample/download-sample.service';
import { ReportsService } from '../../Model/Reports/reports.service';
import { Router } from '@angular/router';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';

@Component({
  selector: 'app-froce-check-out-utility-log-reports',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule, NgbDatepickerModule, JsonPipe,LoaderComponent],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './froce-check-out-utility-log-reports.component.html',
  styleUrl: './froce-check-out-utility-log-reports.component.scss'
})
export class FroceCheckOutUtilityLogReportsComponent {
  public User: any = null;
  isDisabled: boolean = false;
  ForceCheckOutDate: any = null
  ForceDate : any = null
  LogData : any[] = []
  BranchMaster: any[] = [];
  BranchMasterIDs: number[] = [];
  
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    protected common: CommonService,
    private report : ReportsService,
    private tooltip: TooltipService,
    private dateFormate: CustomDateParserFormatter,
    private download : DownloadSampleService,
    private router: Router,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.ComboLoad('Branch');
  }
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
      'IsReport': true
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        }
      },
      complete: () => {
      },
      error: (error) => {
      },
    });
  }
  
  CheckAll(event: any, Type: String) {
    if (Type == 'Branch') {
      if (event.target.checked) {
        this.BranchMasterIDs = this.BranchMaster.map((e: any) => e.BranchMasterID);
      } else {
        this.BranchMasterIDs = [];
      }
    }
  }
  Load(){
    this.User = this.sessionService.GetUserDetails();
    this.ForceCheckOutDate = this.dateFormate.format(this.ForceDate);
    const ids = this.BranchMasterIDs.join(',');
    const logdataselect = {
      SelectType: 'S',
      BranchId: ids,
      AttendanceDate : this.ForceCheckOutDate,
      UserId : this.User.UserId
    } 
    this.isDisabled = true;
    this.report.ForceCheckOutUtilityLogsSelect(logdataselect).subscribe(
      data => {
        if (data && data.Table && data.Table.length > 0) {
          this.LogData = Object.values(data.Table);
          this.download.exportToExcel(this.LogData, "ForceCheckOutUtilityLogs_data");
          this.isDisabled = false;
        }
        else { 
          this.isDisabled = false;
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      }
    );
  }

  close(){
    this.router.navigate(['reports/frontreport']);
  }
}
